import { render, staticRenderFns } from "./SearchNavigation.vue?vue&type=template&id=a4d4f47a&scoped=true&lang=html&"
import script from "./SearchNavigation.vue?vue&type=script&lang=js&"
export * from "./SearchNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d4f47a",
  null
  
)

export default component.exports